module.exports = __webpack_public_path__ + "static/concept_bg_img-0fef8afb830ddb005b386277ab6cdc60.png";